import { useAuth } from 'context/auth.context';
import {
  GetMyProjectsResponse,
  GetMyProjectsRequest,
} from 'core/models/users/project/get-my-projects.model';
import { GetUserReviewApplicationRequest } from 'core/models/users/review/get-user-review-application.model';
import { UserSocial } from 'core/models/users/socials/user-social.model';
import { WalletType } from 'core/models/users/wallet/wallet-address.model';
import { UserV1BaseServerRepo } from 'core/repository/base-server/v1/user.repo';
import { useState, useEffect } from 'react';

export const useInvestments = () => {
  const [projects, setProjects] = useState<GetMyProjectsResponse>();

  useEffect(() => {
    async function fetchData() {
      const request: GetMyProjectsRequest = {};
      const response = await new UserV1BaseServerRepo().getMyProjects(request);
      setProjects(response);
    }
    fetchData();
  }, []);

  return [projects];
};

export class ProfileDetails {
  email?: string = '';
  name?: string = '';
  socialLinks?: UserSocial[] = [];
  wallets?: Map<WalletType, `0x${string}`> = new Map();
  cryptoNetworkId?: number = 1;
  onboardingPhase?: string;
}

export const useProfile = () => {
  const [profile, setProfile] = useState<ProfileDetails>();
  const { user: authUser } = useAuth();

  async function refresh() {
    const request: GetUserReviewApplicationRequest = {};
    const response = await new UserV1BaseServerRepo().reviewApplication(
      request
    );

    const wallets = new Map<WalletType, `0x${string}`>();

    // console.log(`Wallets :${response}`);
    response?.walletAddresses?.forEach((wallet) => {
      wallets.set(wallet.walletType, wallet.address as `0x${string}`);
    });

    setProfile({
      email: response?.emailAddress?.email,
      name: response?.profile?.displayName,
      socialLinks: response?.profile?.socialLinks,
      onboardingPhase: response.onboardingPhase,
      wallets,
      cryptoNetworkId: response?.walletAddresses?.find(
        (wallet) => wallet.walletType === WalletType.MAIN
      )?.cryptoNetworkId,
    });
  }

  useEffect(() => {
    refresh();
  }, [authUser]);

  return { profile, refresh };
};
